(function ($) {
  "use strict";
  var formId;
  var sectionId;

  function sendForm() {
    const contactForm = document.getElementById(formId);
    const successMessage = document.querySelector('#' + sectionId + ' .success-message');
    const errorMessage = document.querySelector('#' + sectionId + ' .w-form-fail');

    contactForm.addEventListener('submit', function(e) {
      e.preventDefault();
      
      const formData = new FormData(contactForm);
      const action = contactForm.getAttribute('action');
      fetch(action, {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json'
        }
      })
      .then(response => {
        console.log(response);
        if (response.ok) {
          contactForm.reset();
          successMessage.style.display = 'block';
        } else {
          errorMessage.style.display = 'block';
          console.error('Form submission failed.');
        }
      })
      .catch(error => {
        console.error('Network error:', error);
      });
    });

  }


  window.formEl = {
      init: function (secId, formId) {
          console.log('Initializing form with sectionId:', secId, 'and formId:', formId);
          if (!secId || !formId) {
              return;
          }

          sectionId = secId;
          formId = formId;
          sendForm();

      }
  };


})(window.jQuery);